import React from 'react'
import Link from 'gatsby-link'
import './navigation.scss';
import slugify from 'slugify'

class Navigation extends React.Component {
  render() {
    const {linkData, isMobile } = this.props;
    const sortedLinks = linkData.sort(function(a, b) {
      return a.node.orderNumber - b.node.orderNumber
    })

    return (
      <div className="navigation">
        <div className="navigation-wrapper">
          {!isMobile &&
            <span className="desktop index-link">
              <Link to={`/categories`}>Index</Link>
            </span>
          }

          {sortedLinks.map((cat, i) => {
            const name = slugify(cat.node.name, { lower: true })

            return (
              <div className="links" key={i}>
                <span className="mobile">
                  <a href={`/${name}`}>
                    {cat.node.name}
                  </a>
                </span>

                <span className="desktop">
                  <a href={`/categories#${name}`}>
                    {cat.node.name}
                  </a>
                </span>
              </div>
            );
          })}

          <span className="desktop">
            <p className="info-link" onClick={this.handleClick.bind(this)}>
              INFO
            </p>
          </span>
        </div>
      </div>
    )
  }

  handleClick() {
    this.props.handleInfoClick()
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation.js